let counter = 0;

/**
 * Create locally unique ID
 */
export const getLUID = () => `${counter++}-${Date.now()}`;
